<template>
  <div>
    <v-dialog v-model="modal" max-width="750" persistent>
      <ManageTemplate
        :templateId="current.id"
        :key="modalKey"
        @close=";(modalKey = !modalKey), (modal = false)"
        @confirm=";(modalKey = !modalKey), list(), (modal = false)"
      />
    </v-dialog>

    <InspectionRoutineOrdenation
      v-if="ordenationTemplate"
      v-model="ordenationModal"
      :template="ordenationTemplate"
      :items="ordenationTemplate.items || []"
      @save="onOrdenationSave"
    />

    <v-dialog v-model="removeModal" max-width="400" persistent>
      <v-card class="card-pad text-center">
        <strong>{{ $t('Remover') }} Template</strong>

        <br />

        <div class="caption--text text-body-2 mb-4">
          {{ $t('Tem certeza de que deseja remover o template') }}
          {{ current.name }}?
        </div>

        <v-btn
          depressed
          :disabled="loading"
          @click="removeModal = false"
          class="ma-1 secondary-button"
        >
          Cancelar
        </v-btn>

        <v-btn
          depressed
          :loading="loading"
          class="ma-1 primary-button"
          @click="remove"
        >
          {{ $t('Remover') }}
        </v-btn>
      </v-card>
    </v-dialog>

    <div class="d-flex my-3">
      <v-spacer></v-spacer>
      <v-btn
        class="secondary-button mr-4"
        depressed
        @click=";(current = {}), (modalKey = !modalKey), (modal = true)"
      >
        {{ $t('Adicionar') }}
      </v-btn>
      <v-btn class="primary-button mr-0" depressed @click="filters = !filters">
        {{ filters ? $t('Fechar') : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-if="filters">
        <v-row class="ma-0" dense>
          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.name"
              :label="$t('Nome do template')"
              class="primary-input"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>

          <v-col cols="12" sm="3">
            <v-autocomplete
              v-model="filter.standardEquipmentId"
              append-icon="mdi-chevron-down"
              :label="$t('Equipamento padrão')"
              class="primary-input"
              outlined
              dense
              hide-details
            ></v-autocomplete>
          </v-col>

          <v-col cols="12" sm="3">
            <v-text-field
              v-model="filter.itemName"
              :label="$t('Nome do item')"
              class="primary-input"
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
        </v-row>

        <div class="d-flex">
          <v-spacer></v-spacer>
          <v-btn class="primary-button ml-2 mt-1" depressed @click="list">
            Filtrar
          </v-btn>
        </div>
      </div>
    </v-expand-transition>

    <v-data-table
      :no-data-text="$t('Nenhum item encontrado')"
      class="main-table"
      :headers="headers"
      :items="templates"
      :items-per-page="20"
      hide-default-footer
      mobile-breakpoint="0"
      hide-default-header
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.createdAt`]="{ item }">
        {{ formatDate(item.createdAt) }}
      </template>

      <template #[`item.type`]="{ item }">
        {{ $t(types[item.type]) }}
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              @click=";(current = item), (modalKey = !modalKey), (modal = true)"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small dark> mdi-pencil-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Editar') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              small
              color="#A42A2AD9"
              style="font-weight: bold"
              dark
              v-bind="attrs"
              @click=";(current = item), (removeModal = true)"
              v-on="on"
              depressed
            >
              <v-icon small color="white"> mdi-trash-can-outline </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Excluir') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              @click="getPrint(item.id)"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small dark> mdi-printer </v-icon>
            </v-btn>
          </template>
          <span>{{ $t('Imprimir') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              class="ma-1"
              color="#BBCF20"
              dark
              @click="openOrdenation(item)"
              v-bind="attrs"
              v-on="on"
              small
              depressed
            >
              <v-icon small dark> mdi-sort </v-icon>
            </v-btn>
          </template>
          <span>Ordenar Itens</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination mx-2">
      <div class="item-pagination block-one">
        <div class="registros" v-if="templates.length">
          <span> 1 - {{ templates.length }} de {{ filter.totalItems }} </span>
        </div>
      </div>

      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="filter.totalPages"
          :total-visible="9"
        ></v-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from '../../../../../services/ApiService'
import ManageTemplate from './manageTemplate'
import InspectionRoutineOrdenation from './InspectionRoutineOrdenation'
import Utils from '../../../../../Utils/FormatDate'

export default {
  name: 'ItensTab',

  components: {
    ManageTemplate,
    InspectionRoutineOrdenation,
  },

  created() {
    this.filter.institutionId = JSON.parse(
      localStorage.getItem('institution')
    ).id

    this.list()
  },

  data() {
    return {
      removeModal: false,
      loading: false,
      current: {},
      modal: false,
      modalKey: false,
      ordenationModal: false,
      ordenationTemplate: null,
      filter: {
        page: 1,
      },
      filters: false,
      templates: [],
      apiService: new ApiService(),
      types: ['Equipamento', 'Setor'],
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Template',
          align: 'center',
          value: 'name',
        },
        {
          text: 'Tipo',
          align: 'center',
          sortable: false,
          value: 'type',
        },
        {
          text: 'Ações',
          align: 'center',
          sortable: false,
          value: 'actions',
        },
      ],
    }
  },

  methods: {
    getPrint(id) {
      this.apiService
        .get(`inspectionRoutineChecklistTemplate/print/${id}`)
        .then((res) => {
          var pdfResult = `data:application/pdf;base64,${res.content}`
          const link = document.createElement('a')
          link.href = pdfResult
          link.setAttribute('download', `Checklist.pdf`)
          document.body.appendChild(link)
          link.click()
        })
    },

    remove() {
      this.loading = true
      this.apiService
        .delete(`inspectionRoutineChecklistTemplate/remove/${this.current.id}`)
        .then(() => {
          this.list()
          this.loading = false
          this.removeModal = false
          this.$toast.success('Template removido!')
        })
        .catch(() => {
          this.loading = false
        })
    },

    formatDate(date) {
      return Utils.dateTime(date)
    },

    list() {
      this.apiService
        .get('inspectionRoutineChecklistTemplate/list/paginate', this.filter)
        .then((response) => {
          this.templates = response.content.templates

          this.filter.totalPages = response.content.pager.totalPages
          this.filter.totalItems = response.content.pager.totalItems
        })
    },

    openOrdenation(item) {
      this.ordenationTemplate = item
      this.ordenationModal = true
    },

    onOrdenationSave(updatedItems) {
      if (this.ordenationTemplate) {
        this.ordenationTemplate.items = updatedItems
      }
    },
  },

  watch: {
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
  },
}
</script>

<style></style>
